import React from 'react';
import { Brain, Cloud, Users } from 'lucide-react';

const ICON_BG_COLOR = "#3B82F6"; // blue-500
const AI_ICON_BG_COLOR = "#8B5CF6"; // violet-500

const reasons = [
  {
    icon: Brain,
    title: "AI Automation Expertise",
    description: "Our team specializes in developing custom AI solutions that automate business processes and eliminate repetitive tasks, delivering measurable ROI.",
    iconColor: AI_ICON_BG_COLOR
  },
  {
    icon: Cloud,
    title: "AWS-Integrated Solutions",
    description: "Unique ability to build AI solutions on robust AWS cloud infrastructure, combining automation with scalable, secure cloud architecture.",
    iconColor: ICON_BG_COLOR
  },
  {
    icon: Users,
    title: "End-to-End Digital Transformation",
    description: "From cloud infrastructure to AI automation, we provide comprehensive support throughout your digital transformation journey.",
    iconColor: ICON_BG_COLOR
  }
];

const WhyChooseUsSection = () => {
  return (
    <div id="about" className="py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            Why Choose Kult.io?
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-300 mx-auto">
            AI automation experts with AWS cloud infrastructure mastery and over 10 years of experience
          </p>
        </div>

        <div className="mt-12 grid gap-8 grid-cols-1 md:grid-cols-3">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div key={index} className="bg-gray-800 rounded-lg p-6 shadow-sm border border-gray-700">
                <div className="flex items-center mb-4">
                  <div
                    style={{ backgroundColor: reason.iconColor }}
                    className="flex items-center justify-center h-12 w-12 rounded-md text-white"
                  >
                    <IconComponent className="h-6 w-6" />
                  </div>
                  <h3 className="ml-3 text-lg font-medium text-white">{reason.title}</h3>
                </div>
                <p className="text-gray-300">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsSection;